<template>
    <div ref="pdfWrapper">
        <pdf
            :src="src"
            :page="i"
            @loading="loaded(i)"
            v-for="i in range"
            :text="false"
            :key="i"
            :scaleRate="2"
        >
        </pdf>
        <Loading-item
            class="loading-item"
            v-show="loadedIndex < total"
        ></Loading-item>
    </div>
</template>
<script>
import LoadingItem from './LoadingItem'
import pdf from './Pdfvuer'

export default {
    props: {
        maxPage: {
            type: Number,
            default: null
        },
        pdfUrl: {}
    },
    data() {
        return {
            total: 0,
            src: '',
            range: 0,
            loadedIndex: 0,
            scrollEl: null,
            oldViewPortContent: ''
        }
    },
    components: {
        pdf,
        LoadingItem
    },
    beforeDestroy() {
        // reset viewport
        if (this.oldViewPortContent) {
            const viewportmeta = document.head.querySelector(
                'meta[name="viewport"]'
            )
            viewportmeta.content = this.oldViewPortContent
        }
    },
    mounted() {
        if (this.pdfUrl) {
            this.loadFile(this.pdfUrl)
        }
        this.scrollEl = this.findScrollParent()
        this.scrollEl.addEventListener(
            'scroll',
            this.throttle(this, this.lazyLoad),
            true
        )
        const viewportmeta = document.head.querySelector(
            'meta[name="viewport"]'
        )
        this.oldViewPortContent = viewportmeta.content
        viewportmeta.content =
            'user-scalable=yes,width=device-width,initial-scale=1.0,maximum-scale=3.0,minimum-scale=1.0'
    },
    methods: {
        findScrollParent() {
            let parent = this.$el
            while (parent) {
                if (
                    parent === document.body ||
                    parent === document.documentElement
                ) {
                    break
                }
                if (!parent.parentNode) {
                    break
                }
                if (/(scroll|auto)/.test(this.overflow(parent))) {
                    return parent
                }
                parent = parent.parentNode
            }
            return window
        },
        overflow(el) {
            return (
                this.style(el, 'overflow') +
                this.style(el, 'overflow-y') +
                this.style(el, 'overflow-x')
            )
        },
        style(el, prop) {
            return typeof getComputedStyle !== 'undefined'
                ? getComputedStyle(el, null).getPropertyValue(prop)
                : el.style[prop]
        },
        loadFile(url) {
            this.src = pdf.createLoadingTask({
                url,
                cMapUrl:
                    'https://oss.cloud.custouch.com/static/cloud/font/cmaps/',
                cMapPacked: true
            })
            this.src
                .then(pdf => {
                    this.total = pdf.numPages
                    this.updateRange(Math.min(this.total, 3))
                    this.$emit('load', { total: this.total })
                })
                .catch(err => {
                    this.$emit('error', err.message)
                })
        },
        loaded(i) {
            this.loadedIndex = Math.max(i, this.loadedIndex)
        },
        throttle(context, fn, ...args) {
            let timer = null
            return function() {
                if (timer) return
                timer = setTimeout(() => {
                    fn.apply(context, args)
                    timer = null
                }, 300)
            }
        },
        lazyLoad() {
            const el = this.$refs.pdfWrapper
            if (
                !this.total ||
                !this.scrollEl ||
                !el ||
                this.range === this.total
            )
                return
            let scrollTop = this.scrollEl.scrollTop
            const children = el.children
            const lastPaintingHeight =
                children[children.length - 1].offsetHeight
            if (
                el &&
                el.offsetHeight - window.innerHeight <=
                    scrollTop + lastPaintingHeight
            ) {
                const range = Math.max(this.range, this.loadedIndex + 3)
                this.updateRange(Math.min(this.total, range))
            }
        },
        updateRange(range) {
            if (this.maxPage != null) {
                if (this.maxPage === this.range) {
                    this.$emit('maxEnd')
                } else {
                    this.range = Math.min(this.maxPage, range)
                }
            } else {
                this.range = range
            }
        }
    }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
.loading-item {
    margin: 0 auto;
    display: flex;
    justify-content: center;
}
</style>
